import React from 'react';
import { AccordionItem } from './Accordion';
import { CtaButton } from './CtaButton';
import { MODULES } from '../lib/constants';
// "Para eso nació este Pack" — the 14 collapsible modules.
export function ModulesSection() {
  return <section className="px-5 py-8" data-id="element-85">
      <div className="mx-auto max-w-md" data-id="element-86">
        <h2 className="text-center font-[Montserrat] text-2xl font-extrabold text-[#e6c168]" data-id="element-87">
          Para eso nació este Pack
        </h2>
        <p className="mt-2 text-center text-sm text-blue-100" data-id="element-88">
          14 módulos ordenados paso a paso para llevarte de cero al aprobado.
        </p>

        <div className="mt-6 space-y-3" data-id="element-89">
          {MODULES.map((m, i) => <AccordionItem key={m.title} index={i} emoji={m.emoji} title={`${i + 1}. ${m.title}`} description={m.description} badge={m.title.toLowerCase().includes('bono standalone') ? undefined : undefined} data-id="element-90" />)}
        </div>

        <div className="mt-6" data-id="element-91">
          <CtaButton data-id="element-92" />
        </div>
      </div>
    </section>;
}